
import ProductCard from 'Vue/components/shared/ProductCard.vue';
import { variantGrouping, IProductQueryResults } from 'Vue/interfaces/ProductFilteringInterfaces';
import Swiper, { Pagination, Navigation } from 'swiper';
import { IProductFilteringTranslations } from 'Vue/interfaces/Interfaces';
Swiper.use([Pagination, Navigation]);

export default {
    name: 'ProductQueryResults',
    components: {
        ProductCard,
    },
    data: () => {
        return {
            moduleData: {} as IProductQueryResults,
            products: [] as variantGrouping[],
            translations: {} as IProductFilteringTranslations,
        };
    },
    methods: {
        getData() {
            let closestParent = this.$refs.pqrResults.closest('.js-product-query-results');
            this.moduleData = JSON.parse(closestParent.getAttribute('data-page-data'));
            this.products = this.moduleData?.products;
        },
        setupRotator() {
            let parent = this.$refs.pqrResults.closest('.js-product-query-results');
            let pqrContainer = parent.querySelector('.pqr');
            let idOfParent = parent.getAttribute('id');
            let carouselParent = this.$refs.pqrSwiperInstance;
            carouselParent.classList.add(`pqr-slider--${idOfParent}`);
            if (this.moduleData.navigationType === 0) {
                carouselParent.classList.add(`pqr-slider--dots`);
                pqrContainer.classList.add('pqr--dots');
            } else {
                carouselParent.classList.add(`pqr-slider--arrows`);
                pqrContainer.classList.add('pqr--arrows');
            }

            let leftArrow = this.$refs.leftArrow;
            let rightArrow = this.$refs.rightArrow;
            let pagination = this.$refs.pagination;
            leftArrow.classList.add(`pqr-slider__arrow-left--${idOfParent}`);
            rightArrow.classList.add(`pqr-slider__arrow-right--${idOfParent}`);
            pagination.classList.add(`pqr-slider__pagination--${idOfParent}`);

            //setup each swiper instance
            let swiper: any = new Swiper(`.pqr-slider--${idOfParent}`, {
                // Optional parameters
                slidesPerView: 1,
                slidesPerGroup: 1,
                navigation:
                    this.moduleData.navigationType === 1
                        ? {
                              nextEl: `.pqr-slider__arrow-right--${idOfParent}`,
                              prevEl: `.pqr-slider__arrow-left--${idOfParent}`,
                          }
                        : false,

                pagination:
                    this.moduleData.navigationType === 0
                        ? {
                              el: `.pqr-slider__pagination--${idOfParent}`,
                              type: 'bullets',
                              clickable: true,
                          }
                        : false,
                spaceBetween: 20,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    480: {
                        slidesPerView: this.moduleData.visibleNumberProductsShownInSlider >= 2 ? 2 : 1,
                        slidesPerGroup: this.moduleData.visibleNumberProductsShownInSlider >= 2 ? 2 : 1,
                    },
                    768: {
                        slidesPerView: this.moduleData.visibleNumberProductsShownInSlider > 2 ? 3 : this.moduleData.visibleNumberProductsShownInSlider === 2 ? 2 : 1,
                        slidesPerGroup: this.moduleData.visibleNumberProductsShownInSlider > 2 ? 3 : this.moduleData.visibleNumberProductsShownInSlider === 2 ? 2 : 1,
                    },
                },
                on: {
                    init: function () {},
                },
            });
            swiper.init();
        },
        removeComparisonItem() {
            // /console.log('comparison item removed');
        },
        getTranslations() {
            let productQParentDivs = document.querySelectorAll('.pqr-module');
            let translationsArray = [];
            productQParentDivs.forEach((pqr) => {
                if (pqr.getAttribute('data-translations')) {
                    let parsedTranslations = JSON.parse(pqr.getAttribute('data-translations'));
                    translationsArray.push(parsedTranslations);
                }
            });

            let translations = translationsArray.reduce(function (result, currentObject) {
                for (let key in currentObject) {
                    if (currentObject.hasOwnProperty(key)) {
                        result[key] = currentObject[key];
                    }
                }
                return result;
            }, {});
            return translationsArray.length ? translations : {};
        },
    },
    mounted() {
        this.getData();
        this.setupRotator();
    },
    created() {
        this.translations = this.getTranslations();
    },
};
